import { render } from "./MyNotifications.vue?vue&type=template&id=63b809d0&scoped=true"
import script from "./MyNotifications.vue?vue&type=script&lang=ts"
export * from "./MyNotifications.vue?vue&type=script&lang=ts"

import "./MyNotifications.vue?vue&type=style&index=0&id=63b809d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63b809d0"

export default script